import { Money } from "../common/money";

export class LoanProduct {
    percentageInterestRate: number;
    minimumNumberOfMonths: number;
    maximumNumberOfMonths: number;
    percentageIncreaseMonthStep: number;
    percentageIncrease: number;
    storeCostPrice: Money;
    hotDeal: boolean;
    penaltyPercentage: number;
    payAsYouGoDetails : PayAsYouGoDetails;
    constructor({
        percentageInterestRate,
        minimumNumberOfMonths,
        maximumNumberOfMonths,
        percentageIncreaseMonthStep,
        percentageIncrease,
        storeCostPrice,
        hotDeal,
        penaltyPercentage,
        payAsYouGoDetails ,
    } : LoanProduct) {
        this.percentageInterestRate = percentageInterestRate;
        this.minimumNumberOfMonths = minimumNumberOfMonths;
        this.maximumNumberOfMonths = maximumNumberOfMonths;
        this.percentageIncreaseMonthStep = percentageIncreaseMonthStep;
        this.percentageIncrease = percentageIncrease;
        this.storeCostPrice = storeCostPrice;
        this.hotDeal = hotDeal;
        this.penaltyPercentage = penaltyPercentage;
        this.payAsYouGoDetails  = payAsYouGoDetails ;
    }
}

export class PayAsYouGoDetails{

    costPerKwh: Money;

    constructor({
        costPerKwh
    }:PayAsYouGoDetails){
        this.costPerKwh = costPerKwh;
    }
}

export class CreateOrEditLoanProduct {
    percentageInterestRate: number;
    minimumNumberOfMonths: number;
    maximumNumberOfMonths: number;
    percentageIncreaseMonthStep: number;
    percentageIncrease: number;
    storeCostPrice: number;
    hotDeal: boolean;
    penaltyPercentage: number;
    costPerKwh: number;

    constructor({
        percentageInterestRate,
        minimumNumberOfMonths,
        maximumNumberOfMonths,
        percentageIncreaseMonthStep,
        percentageIncrease,
        storeCostPrice,
        hotDeal,
        penaltyPercentage,
        costPerKwh,
    } : CreateOrEditLoanProduct) {
        this.percentageInterestRate = percentageInterestRate;
        this.minimumNumberOfMonths = minimumNumberOfMonths;
        this.maximumNumberOfMonths = maximumNumberOfMonths;
        this.percentageIncreaseMonthStep = percentageIncreaseMonthStep;
        this.percentageIncrease = percentageIncrease;
        this.storeCostPrice = storeCostPrice;
        this.hotDeal = hotDeal;
        this.penaltyPercentage = penaltyPercentage;
        this.costPerKwh = costPerKwh
    }
}